import { render, staticRenderFns } from "./ThreeColumnText.vue?vue&type=template&id=0cd69949&scoped=true&"
import script from "./ThreeColumnText.vue?vue&type=script&lang=js&"
export * from "./ThreeColumnText.vue?vue&type=script&lang=js&"
import style0 from "./ThreeColumnText.vue?vue&type=style&index=0&id=0cd69949&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cd69949",
  null
  
)

export default component.exports